<div class="card">
<div class="container-rating-start">
    <app-rating-star [rating]=comment.rating style="padding-top: 15px; padding-right: 10px;"></app-rating-star>
</div>
    <div class="card-body">
    <p class="card-text"  [innerHTML]="comment.comment" style="text-align: justify;"></p>
    </div>
    <div class="card-footer">
          <img src="../../../../assets/images/reviews/world/{{comment.country}}"
                      alt="{{comment.country}}" class="flag">
      <small class="text-muted"> {{comment.name}},
            {{comment.date |date: "MMM yyyy"}}</small>
    </div>
  </div>
